<h2 mat-dialog-title>Shared Download Settings</h2>
<mat-dialog-content style="height: 375px; width: 500px; justify-content: flex-start;">
    <div style=" margin: 4px; display: flex; flex-direction: column; justify-content: space-around; height: 100%;">
        <div>
            <div style="padding:4px;">
                <p>To provide extra security, please provide a password and a date for the link to expire, if
                    desired.
                </p>
                <p>Please be sure to handle the password securely.</p>
            </div>
            <div style="padding: 12px 0px;">
                <mat-checkbox [(ngModel)]="isProductionShared" (change)="toggleFormState()">
                    Shared. Allow users without account access to download this Production.
                </mat-checkbox>
            </div>
            <div style="padding-top: 8px;">
                Please generate a link to share. A valid shared link requires a password with at least 4 characters.
            </div>
        </div>
        <div style="margin-bottom: 8px;">
            <form [formGroup]="sharedLinkForm">
                <mat-error *ngIf="sharedLinkForm.get('password')?.errors?.['required']">
                    Password is required to generate a shared link.
                </mat-error>
                <mat-error *ngIf="sharedLinkForm.get('password')?.errors?.['pattern']">
                    Password can not contain any of the following characters: \/:*?<>|^
                </mat-error>
                <mat-error *ngIf="sharedLinkForm.get('password')?.errors?.['minlength']">
                    Password must be at lest 4 characters.
                </mat-error>
                <mat-error *ngIf="sharedLinkForm.get('password')?.errors?.['maxlength']">
                    Password cannot exceed 256 characters.
                </mat-error>
                <div style="display: flex; justify-content: space-between; flex-direction: row;">
                    <div style="width: 100%;">
                        <mat-form-field color="primary" style="width: 100%;">
                            <mat-label>Password</mat-label>
                            <input matInput formControlName="password" type="password" />
                        </mat-form-field>
                    </div>
                </div>
                <div style="display: flex; justify-content: space-between;">
                    <div style="width: 100%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Choose an expiration date</mat-label>
                            <input matInput [matDatepicker]="expDatePicker" formControlName="expirationDate">
                            <mat-datepicker-toggle matSuffix [for]="expDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #expDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions
    style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <button *ngIf="isProductionShared" mat-raised-button color="primary" (click)="updateShared()"
        [disabled]="sharedLinkForm.invalid || !sharedLinkForm.dirty || !isProductionShared">Generate Link</button>
    <button *ngIf="!isProductionShared && !!sharedJob?.sharedId" mat-raised-button color="primary" (click)="removeSharedAccess()">Remove Shared Link</button>
    <button mat-raised-button mat-dialog-close (click)="close()">Cancel</button>
</mat-dialog-actions>